'use client';

import Reveal from './Reveal';

export default function Disclaimer() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-12">
      <Reveal>
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <p className="text-sm text-yellow-900">
            この回答が正確な正解とは限りません。重要な判断の前に、税務関係者・専門家への相談をおすすめします。
          </p>
        </div>
      </Reveal>
    </section>
  );
}
